// extracted by mini-css-extract-plugin
export default {"parent":"ParentContainer_parent__+9lZg"};